module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/ig/ig-09-94fafcd42a4a72e520fb6619be4373b1.jpg";